/**
 * Quem enxerga o "Ditar" (spec 009).
 *
 * Regra (14/09/2026, decisão do Leopoldo): **quem prescreve, dita**. O botão
 * aparece sozinho para MEDICO e ADMIN, em qualquer computador, sem comando
 * nenhum — e continua invisível para secretaria, recepção e financeiro, que
 * não assinam receita.
 *
 * Antes era só `localStorage`, e isso custou caro: a chave é por ORIGEM, então
 * ligá-la no localhost não valia no dratento.com.br, e o botão ficava cinza em
 * produção sem explicar por quê.
 *
 * O `localStorage` continua existindo, mas só como override manual:
 *   - `'1'` liga em qualquer papel (testar com outro login);
 *   - `'0'` DESLIGA mesmo pro médico (é o kill switch, se der problema no
 *     atendimento e não der pra esperar um deploy).
 */

import { Role } from '@/types/auth';

const LS_KEY = 'dratento.voice.enabled';

/** Papéis que prescrevem — são os que ganham o botão por padrão. */
const PAPEIS_COM_DITADO: ReadonlySet<string> = new Set([Role.MEDICO, Role.ADMIN]);

function override(): '1' | '0' | null {
  try {
    const v = localStorage.getItem(LS_KEY);
    return v === '1' || v === '0' ? v : null;
  } catch {
    // Modo privado / storage bloqueado: sem override, vale o papel.
    return null;
  }
}

/** Kill switch ligado (`'0'`) — nada do ditado roda, nem em segundo plano. */
export function isVoiceKilled(): boolean {
  return override() === '0';
}

/**
 * @param role papel do usuário logado (`useAuth().role`). Sem ele, só o
 *             override e o ambiente de desenvolvimento ligam.
 */
export function isVoiceEnabled(role?: string): boolean {
  const forcado = override();
  if (forcado === '0') return false;
  if (forcado === '1') return true;
  if (import.meta.env.DEV) return true;
  return !!role && PAPEIS_COM_DITADO.has(role);
}
